// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html{background-color:#fafafa;height:100%}.kh .bg-info,.kh .bg-primary,.kh .bg-success,.kh .step.reached{background-color:#00aeef!important}.kh .hover\\:bg-info-dark:hover,.kh .hover\\:bg-success-dark:hover{background-color:#0e8ecb!important}.kh .question-big{color:#00aeef!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
